export function getPlanItems(plan) {
  return Array.isArray(plan?.items) ? plan.items : []
}

export function getPendingBalance(plan) {
  return Math.max(
    0,
    Number(plan?.totalEstimated || 0) - Number(plan?.totalPaid || 0)
  )
}

export function findNextSchedulableItem(plan) {
  const items = getPlanItems(plan)

  return (
    items.find((item) => {
      const status = String(item?.status || "").toUpperCase()
      if (["DONE", "CANCELLED", "SCHEDULED"].includes(status)) return false
      if (item?.appointmentId || item?.appointment?.id) return false
      return true
    }) || null
  )
}

export function hasPendingItems(plan) {
  return getPlanItems(plan).some(
    (item) => !["DONE", "CANCELLED"].includes(String(item?.status || "").toUpperCase())
  )
}

export function hasScheduledItems(plan) {
  return getPlanItems(plan).some(
    (item) => String(item?.status || "").toUpperCase() === "SCHEDULED"
  )
}

export function getPlanPatientName(plan) {
  return plan?.patient
    ? `${plan.patient.firstName || ""} ${plan.patient.lastName || ""}`.trim()
    : "Paciente"
}

export function getRecommendedDoctor(nextItem) {
  return (
    nextItem?.assignedDoctorName ||
    nextItem?.assignedDoctor?.name ||
    nextItem?.suggestedDoctorName ||
    nextItem?.suggestedDoctor?.name ||
    nextItem?.appointment?.doctor?.name ||
    "-"
  )
}

export function getNextActionLabel({ status, nextItem, hasScheduled }) {
  if (status === "COMPLETED") return "Plan completado"
  if (nextItem) return "Agendar siguiente"
  if (hasScheduled) return "Dar seguimiento"
  return "Revisar plan"
}